var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isPopinDisplayed,
          expression: "isPopinDisplayed",
        },
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: { callback: _vm.popin_covid19Displayed_callback },
          expression: "{ callback: popin_covid19Displayed_callback }",
        },
      ],
      staticClass: "popin-modal centered",
      attrs: { id: "covid19" },
    },
    [
      _c("div", { staticClass: "popin-container" }, [
        _c(
          "div",
          {
            staticClass: "popin-closure",
            on: { click: _vm.popin_covid19Closed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "popin" }, [
      _c("div", { staticClass: "popin-content" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v("Réouverture le 9 juin !"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "popin-content-container" }, [
          _c("p", [
            _vm._v(
              '\n                        Pour que votre voyage se déroule dans de bonnes conditions de sécurité, Lock Quest adhère à la charte "Joueurs en confiance"\n                    '
            ),
          ]),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_1.png" } }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_2.png" } }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_3.png" } }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_4.png" } }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_5.png" } }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_6.png" } }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_7.png" } }),
          _vm._v(" "),
          _c("img", { attrs: { src: "/public/assets/images/Covid_8.png" } }),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }